<script>
  import { filter } from 'rxjs';
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import { filterText } from './textFilter';
  import { a } from '../../../shared/globalState/a';

  export let data;
  export let placeholder;
  export let dataSearchPropertyName;
  export let columns;
  export let isFocused;

  var keys = [];
  var pointer = 0;
  var cn = 'auto-items';
  var hcn = 'autocomplete-item-hightlight';
  var dispatch = createEventDispatcher();
  var selAutoLeftProp = '--select-autocomplete-left';
  var selAutoTopProp = '--select-autocomplete-top';
  var selAutoWidthProp = '--select-autocomplete-width';

  export let left;
  export let top;

  let container;
  let optionsContainer;
  let resizeObserver;

  onMount(function () {
    resizeObserver = new ResizeObserver((entries) => {
      let rect = container.getBoundingClientRect();

      document.documentElement.style.setProperty(selAutoLeftProp, rect.x + left + 'px');
      document.documentElement.style.setProperty(selAutoTopProp, rect.y + top + rect.height + 2 + 'px');
      document.documentElement.style.setProperty(selAutoWidthProp, rect.width + 'px');
    });
    resizeObserver.observe(container);
  });

  onDestroy(function () {
    resizeObserver.disconnect();
  });

  function handleInput(event) {


    
    if (event.key === 'Escape') {
      a.showBlockSearch$.next(false);
    }

    if (!filterText(event.key)) {
      keys.length = 0;
      pointer = 0;
      return;
    }

    var autocomplete = event.target;
    var v = autocomplete.value;

    optionsContainer.style.display = 'block';

    if (event.key === 'Delete' && checkSelection(autocomplete)) {
      keys.length = 0;
      pointer = 0;
      clearAll();
      optionsContainer.style.display = 'none';
      return;
    } else if (event.key === 'Backspace') {
      if (v.length) {
        keys = v.split('');
      }

      keys.pop();
      pointer = 0;
      if (keys.length === 0) {
        clearAll();
        optionsContainer.style.display = 'none';
        return;
      }
    } else if (event.key === 'ArrowDown') {
      // подсветить первый по порядку div
      event.preventDefault();
      let divs = document.querySelectorAll(`.${cn}`);

      pointer++;

      if (pointer >= divs.length + 1) {
        pointer--;
      }
      if (divs.length > 0) {
        clearHighlight(divs);
        divs[pointer - 1].classList.add(hcn);
      }

      return;
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      let divs = document.querySelectorAll(`.${cn}`);

      pointer--;

      if (pointer <= 0) {
        pointer++;
      }
      if (divs.length > 0) {
        clearHighlight(divs);
        divs[pointer - 1].classList.add(hcn);
      }

      return;
    } else if (event.key === 'Enter') {
      let divs = document.querySelectorAll(`.${cn}`);

      
      if (divs.length > 0 && pointer > 0) {

        // преобразуем nodeList в массив
        let nodeArray = Array.from(divs[pointer - 1].childNodes);

        // находим индекс свойства, по которому происходит поиск элементов
        let index = columns.findIndex((c) => c === 'code');
        
        // извлечём текст из элемента с найденным индексом, этот текст и будет выбранным значением
        let selectedItem = nodeArray.map((node) => {
          return node.textContent;
        })[index];

        autocomplete.value = selectedItem;
        autocomplete.dispatchEvent(new Event('input'));
        dispatch('selected', selectedItem);

        keys.length = 0;

        selectedItem.split('').forEach((s) => {
          keys.push(s);
        });
        clearAll();
        optionsContainer.style.display = 'none';
        return;
      } else {
        dispatch('selected', autocomplete.value);
        keys.length = 0;
        clearAll();
        optionsContainer.style.display = 'none';
        return;
      }
    } else {
      pointer = 0;
      keys.push(event.key);
    }

    var s = keys.join('');

    let filteredData = data.filter((item) => {
      if (item instanceof Object) {
        let o;
        if(dataSearchPropertyName.includes('&')){
          let props = dataSearchPropertyName.split('&').map(t=>t.trim());
          let prop1 = props[0];
          let prop2 = props[1];
          o = item.data[prop1].toLowerCase().includes(s.toLocaleLowerCase()) || item.data[prop2].toLocaleLowerCase().includes(s.toLowerCase());
        }
        else{
          o = item.data[dataSearchPropertyName].toLowerCase().startsWith(s.toLowerCase());

        }
        return o;
      } else {
        return item.toLowerCase().startsWith(s.toLowerCase());
      }
    }).slice(0, 10);

    clearAll();

    filteredData.forEach((s) => {
      let div = document.createElement('div');
      div.classList.add(cn);
      if (s instanceof Object) {

        div.style.display = 'grid';
        div.style.gridTemplateColumns = `repeat(${columns.length}, 1fr)`;
        div.style.columnGap = '1em';
        
        columns.forEach((c) => {
          
          let span = document.createElement('span');
          if(c === 'img'){
            let img = document.createElement('img');
            let imgSrc = `./assets/imgs/aliases/${s.data['code']}.svg`;
            img.src = imgSrc;
            img.alt = 'Изображение не найдено'; 
            img.style.transform = 'scale(0.5)';
            span.style.marginRight = '1em';
            span.append(img);
          }
          else{
            span.textContent = s.data[c];
          }
          span.style.alignSelf = 'center';
          div.append(span);
        });
        
      } else {
        div.textContent = s;
      }
      div.style.paddingLeft = '.25em';
      div.style.paddingRight = '.25em';
      optionsContainer.append(div);
    });
  }
  function clearAll() {
    // удалить все элементы с классом cn
    Array.from(optionsContainer.querySelectorAll(`.${cn}`)).forEach((el) => {
      el.remove();
    });
  }
  function clearHighlight(divs) {
    divs.forEach((div) => {
      div.classList.remove('autocomplete-item-hightlight');
    });
  }
  function checkSelection(autocomplete) {
    let selectionStart = autocomplete.selectionStart;
    let selectionEnd = autocomplete.selectionEnd;

    if (selectionStart !== selectionEnd) {
      return true;
    } else {
      return false;
    }
  }
  
  function focus(element){
    if(isFocused){
      element.focus();
    }
  }
</script>

<div class="autocontainer" bind:this={container}>
  <input type="text" class="autofield" on:keydown={handleInput} {placeholder} use:focus />
  <div class="options-container" bind:this={optionsContainer}></div>
</div>

<style>
  .autofield {
    padding: 0 0.25em;
  }
  .options-container {
    position: absolute;
    left: var(--select-autocomplete-left);
    top: var(--select-autocomplete-top);
    background-color: white;
    border-radius: 0.25em;
    width: var(--select-autocomplete-width);
    max-height: 75vh;
    overflow-y: scroll;
    display: none;
    border: 1px solid slategray;
  }
</style>
